// utils/scrollLock.ts

/**
 * Disables body scrolling by fixing the body's position and preserving the current scroll position.
 */
export function enableScrollLock(): void {
	const element = document.body;

	// If scroll is already disabled, do nothing
	if (element.classList.contains('scroll--disabled')) {
		return;
	}

	// Calculate scrollbar width
	const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

	// Save the current scroll position
	const scrollY = window.scrollY || window.pageYOffset;

	// Apply styles to disable scrolling
	element.style.position = 'fixed';
	element.style.top = `-${scrollY}px`;
	element.style.left = '0';
	element.style.right = '0';
	element.style.overflow = 'hidden';
	if (scrollBarWidth > 0) {
		// Set the css var for scrollbar width
		document.documentElement.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`);
		element.style.overflowY = 'scroll';
	}

	// Add a class to indicate scrolling is disabled
	element.classList.add('scroll--disabled');

	// Store the scroll position
	element.setAttribute('data-scrollY', scrollY.toString());
}

/**
 * Enables body scrolling by removing the fixed position and restoring the scroll position.
 * @param {HTMLElement} [scrollContainer] - Optional. The element to remove the scroll lock from. Defaults to `document.body`.
 */
export function disableScrollLock(scrollContainer?: HTMLElement): void {
	const element = scrollContainer || document.body;

	// If scroll is already enabled, do nothing
	if (!element.classList.contains('scroll--disabled')) {
		return;
	}

	// Retrieve the saved scroll position
	const scrollY = element.getAttribute('data-scrollY');

	// Remove styles that were applied to disable scrolling
	element.style.position = '';
	element.style.top = '';
	element.style.left = '';
	element.style.right = '';
	element.style.overflow = '';

	// Remove the class indicating scrolling was disabled
	element.classList.remove('scroll--disabled');
	// Remove the CSS custom property
	document.documentElement.style.removeProperty('--scrollbar-width');

	// Restore the scroll position
	if (scrollY !== null) {
		window.scrollTo(0, parseInt(scrollY, 10));
		element.removeAttribute('data-scrollY');
	}
}
